import { createStore, createLogger } from 'vuex'
import { mutations } from './mutations'
import { actions } from './actions'
import { getters } from './getters'

const debug = process.env.NODE_ENV !== 'production' // TODO what if 'prod'

export default createStore({
  state: {
    menu: null,
    showWarningModal: false,
    secret: undefined,
    userManagement: {},
    authenticated: undefined,
    permissions: [],
  },
  mutations: mutations,
  actions: actions,
  getters: getters,
  strict: debug,
  plugins: [
    createLogger({
      logActions: debug ? true: false,
      logMutations: false,
      logger: console,
    }),
  ],
})
